import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CheckEmailRoutingModule } from './check-email-routing.module';
import { CheckEmailComponent } from './components/check-email/check-email.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    CheckEmailComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    CheckEmailRoutingModule
  ]
})
export class CheckEmailModule { }
